<div style="background-color: #F8F8F8; border-radius: 10px;">

    <div class="col-md-12 col-lg-12 col-12" style="padding: 10px 15px 0px 20px; padding-bottom: 0px;">
        <div class="col-md-10 col-lg-10 col-10" style="display: inline-block; padding: 0px;">
            <span class="mobView" style="font-size: 22px; margin-right: 10px; display: inline-block; display: none !important;"><i class="fa fa-chevron-left"></i></span>
            <h4 style="display: inline-block;">{{isReceive ? 'In / Receive Items' : 'Out / Issue Items'}}</h4>
        </div>
        <div class="col-md-2 col-lg-2 col-2" style="display: inline-block; padding: 0px;">
            <i class="closeMdl zmdi zmdi-close" style="float: right; margin-top: 0px; top: 4px;  cursor: pointer;
            text-align: center; padding: 6px 10px !important;" (click)="closeModal()"></i>
        </div>
    </div>

    <!-- Direct -->
    <!-- <div style="margin-top: 10px; background-color: #E884210a;"> 
        <div style="padding-left: 15px; padding-right: 15px; color: #E88421; padding-top: 10px; padding-bottom: 10px; font-size: 20px; font-weight: bold; font-size: 16px;">Direct Transactions</div>        
        <div style="padding-bottom: 10px; padding-left: 15px; padding-right: 15px;">
            
            <div style="display: block;">
                <div class="btns btnMargin" style="display: inline-block; width: 48%;">
                    <div class="btn btn-orange" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 14px; line-height: 35px;" (click)="openItemSelect(selectItem, 1)">Dispatch</div>
                </div>
                
                <div class="btns btnMargin" style="display: inline-block; width: 48%;">
                    <div class="btn btn-orange" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 14px; line-height: 35px;" (click)="openItemSelect(selectItem, 5)">GNR</div>
                </div>
            </div>
                
            <div style="display: block;">
                <div class="btns btnMargin" style="display: inline-block; margin-top: 10px; width: 48%;">
                    <div class="btn btn-orange" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 14px; line-height: 35px;" (click)="openItemSelect(selectItem, 3)">Issue Direct</div>
                </div>
                
                <div class="btns btnMargin" style="display: inline-block; margin-top: 10px; width: 48%;">
                    <div class="btn btn-orange" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 14px; line-height: 35px;" (click)="openItemSelect(selectItem, 4)">Return Direct</div>
                </div>
            </div>
                
            <div style="display: block;">
                <div class="btns btnMargin" style="display: inline-block; margin-top: 10px;">
                    <div class="btn btn-orange" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 14px; line-height: 35px;" (click)="openItemSelect(selectItem, 2)">Store Transfer</div>
                </div>
            </div>

        </div>
    </div> -->

    <!-- Issue -->
    <div *ngIf="!isReceive"> 
        <!-- <div style="padding-left: 15px; padding-right: 15px; color: #E88421; padding-top: 10px; padding-bottom: 10px; font-size: 20px; font-weight: bold; font-size: 16px;">Issue Transactions</div>         -->
        <div style="padding-bottom: 10px; padding-left: 15px; padding-right: 15px;">
            
            <div style="display: block;">
                <div class="btns btnMargin" style="display: inline-block; margin-top: 5px;">
                    <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="openItemSelect(selectItem, 1, false)">Dispatch</div>
                </div>
                
                <div class="btns btnMargin" style="display: inline-block; margin-top: 10px;">
                    <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="openItemSelect(selectItem, 3, false)">Issue to User</div>
                </div>

                <div *ngIf="isIndian" class="btns btnMargin" style="display: inline-block; margin-top: 10px;">
                    <!-- <div class="btn btn-issuGreen" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 14px; line-height: 35px;" (click)="openItemSelect(selectItem, 6, true)">Issue for Production</div> -->
                    <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="issueProduction(6)">Issue for Production</div>
                </div>
                <div *ngIf="isIndian" class="btns btnMargin" style="display: inline-block; margin-top: 10px;">
                    <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="redirectBasicPrd()">Quick Production Entry (Backflush)</div>
                </div>

                <div class="btns btnMargin" style="display: inline-block; margin-top: 10px;">
                    <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="openItemSelect(selectItem, 2, false)">Transfer to Other Store</div>
                </div>

                <div class="btns btnMargin" style="display: inline-block; margin-top: 10px;margin-bottom: 10px;">
                    <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="openItemSelect(selectItem, 7, false)">Job Work (Out) - Dispatch</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Job -->
    <!-- <div style="margin-top: 10px; background-color: #1F628E0A;">
        <div style="padding-left: 15px; padding-right: 15px; color: #1F628E; padding-top: 10px; padding-bottom: 10px; font-size: 20px; font-weight: bold; font-size: 16px;">Production Transactions</div>        
        
        <div style="padding-bottom: 10px; padding-left: 15px; padding-right: 15px;">
            <div class="btns2 btnMargin" style="display: inline-block; padding-bottom: 10px;">
                <div class="btn btn-blue" [routerLink]="['/transactionJobs']" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 14px; line-height: 35px;">Mtl Consumption</div>
            </div>
    
            <div class="btns2 btnMargin" style="display: inline-block; padding-bottom: 10px;">
                <div class="btn btn-blue" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 14px; line-height: 35px;">Scrap</div>
            </div>

            <div class="btns2 btnMargin" style="display: inline-block; padding-bottom: 10px;">
                <div class="btn btn-blue" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 14px; line-height: 35px;">Issue Job</div>
            </div>
        </div>
    </div> -->

    <!-- Receive -->
    <div *ngIf="isReceive">
        <!-- <div style="padding-left: 15px; padding-right: 15px; color: #1F628E; padding-top: 10px; padding-bottom: 10px; font-size: 20px; font-weight: bold; font-size: 16px;">Receive Transactions</div>         -->
        
        <div style="padding-left: 15px; padding-right: 15px;">
            <div class="btns2 btnMargin" style="display: inline-block; padding-bottom: 10px; margin-top: 5px;">
                <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="openItemSelect(selectItem, 5, false)">Purchase Inward (GRN)</div>
            </div>
    
            <div class="btns2 btnMargin" style="display: inline-block; padding-bottom: 10px;">
                <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="openItemSelect(selectItem, 4, false)">Receive from User</div>
            </div>
        </div>

        <div style="padding-left: 15px; padding-right: 15px; margin-bottom: 10px;">
            <div *ngIf="isIndian && !isPrdBasic" class="btns2 btnMargin" style="display: inline-block; padding-bottom: 10px;">
                <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="issueProduction(8)">Receive from Production</div>
            </div>
            <div *ngIf="isIndian && isPrdBasic" class="btns2 btnMargin" style="display: inline-block; padding-bottom: 10px;">
                <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="redirectBasicPrd()">Receive from Production</div>
            </div>
            <div class="btns btnMargin" style="display: inline-block; padding-bottom: 10px;">
                <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="issueProduction(7)">Receive Unused</div>
            </div>
            <div class="btns btnMargin" style="display: inline-block; padding-bottom: 10px;">
                <div class="btn btn-issueBlue bgwhite blueBrdr" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 13px; line-height: 35px;" (click)="openItemSelect(selectItem, 8, false)">Job Work (Out) - Receive</div>
            </div>
        </div>

    </div>

    <div style="margin-top: 10px; background-color: #0080800A; display: none;">
        <!-- <div style="padding-left: 15px; padding-right: 15px; color: #DAA520; padding-top: 10px; padding-bottom: 10px; font-size: 20px; font-weight: bold;">Purchase Goods</div>         -->
        <div style="padding-left: 15px; padding-right: 15px;">
            <div class="btns2 btnMargin" style="display: inline-block; padding-bottom: 10px; padding-top: 10px;">
                <div class="btn btn-teal" style="padding-left: 15px; padding-right: 15px; width: 100%; font-size: 14px; line-height: 35px;">Purchase Goods</div>        
            </div>
        </div>
    </div>

    <div style="margin-top: 10px; background-color: #4CAF500A; display: none;">
        <!-- <div style="padding-left: 15px; padding-right: 15px; color: #1F628E; padding-top: 10px; padding-bottom: 10px; font-size: 20px; font-weight: bold;">Purchase Dispatch</div>         -->
        <div style="padding-left: 15px; padding-right: 15px;">
            <div class="btns2 btnMargin" style="display: inline-block; padding-bottom: 10px; padding-top: 10px;">
                <div class="btn btn-save" style="padding-left: 15px; padding-right: 15px; display: block; font-size: 14px; line-height: 35px;">Sales Dispatch</div>        
            </div>
        </div>
    </div>
</div>

<!-- Item Modal -->
<ng-template #selectItem let-modal>
    <app-multiple-select-item></app-multiple-select-item>
</ng-template>

